
import { ContactLoanoutDto } from '@hub/generated/models';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { eColumnType, eContactType } from '@hub/generated/enums';
import { NotificationService } from '@hub/services/NotificationService';
import { SubGridItem } from '@hub/models/common/ui/SubGridItem';
import { Functions } from '@hub/common/Functions';

@Component({
	selector: 'hub-loanouts',
	templateUrl: './loanouts.component.html'
})
export class LoanoutsComponent implements OnInit {

	constructor(
	) { }

	public columns: SubGridItem[] = [
		{ Field: 'LoanoutName', Header: 'Name', ColumnType: eColumnType.PlainText },
		{ Field: 'IsActive', Header: 'Active', ColumnType: eColumnType.Checkbox },
		{ Field: 'TaxNumber', Header: 'Taxpayer ID', ColumnType: eColumnType.PlainText },
		{ Field: 'IsForeign', Header: 'FC', ColumnType: eColumnType.Checkbox },
		{ Field: 'IsUk', Header: 'Is UK', ColumnType: eColumnType.Checkbox },
		{ Field: 'IsAus', Header: 'Is AUS', ColumnType: eColumnType.Checkbox },
		{ Field: 'IsGSTReg', Header: 'GST reg', ColumnType: eColumnType.Checkbox },
	];

	@Input() loanouts: ContactLoanoutDto[] = [];
	@Input() selection: ContactLoanoutDto[] = [];
	@Input() isFinancialForm: boolean = true;

	@Output() onDelete: EventEmitter<ContactLoanoutDto[]> = new EventEmitter<ContactLoanoutDto[]>();
	@Output() onOpenDialog: EventEmitter<any> = new EventEmitter<any>();
	@Output() onSelectItem: EventEmitter<ContactLoanoutDto[]> = new EventEmitter<ContactLoanoutDto[]>();

	ngOnInit() {
		this.getStringFromEnums(this.loanouts);
	}

	public delete() {
		this.onDelete.emit(this.selection);
	}

	public onSelect(event: any) {
		this.selection = event;
		this.onSelectItem.emit(this.selection);
	}

	public openCreateOrEditDialog(event: boolean) {
		this.onOpenDialog.emit(event);
	}

	private getStringFromEnums(data) {
		for (let i = 0; i < data.length; i++) {
			data[i].ContactTypeId = !!data[i].ContactTypeId ? Functions.getEnumName(eContactType, data[i].ContactTypeId) : data[i].ContactTypeId;
		}
	}
}
